"use strict";
import React from "react";
import { Select, MenuItem, Grid } from "@mui/material";
import GlobalButton from "../Buttons/GlobalButton";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { useNavigate } from "react-router-dom";
import { primaryColor, secondaryColor } from "../../utils/constants";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    width: "0.1px",
    borderRadius: "var(--radius-md)",
    position: "relative",
    border: "none",
    fontSize: "var(--font-size-normal)",
    backgroundColor: `${primaryColor}`,
    padding: "0px 0px 5px 4px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    color: `${secondaryColor}`,
    fontFamily: "Livvic",
  },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  "& .MuiSelect-select": {
    backgroundColor: `${primaryColor} !important`,
    color: `${secondaryColor} !important`,
  },
  "& .MuiSelect-icon": {
    fontSize: "var(--font-size-normal)",
  },
  "& .MuiPaper-root": {
    backgroundColor: "rgba(0, 0, 0, 0.1) !important",
  },
}));


const StyledMenuItem = styled(MenuItem)({
    backgroundColor: "rgba(245, 245, 245, 0.7) !important",
    color: `${secondaryColor} !important`,
    "&.Mui-selected": {
        backgroundColor: "rgb(255, 255, 255, 0.7) !important",
        color: `${secondaryColor} !important`,
        fontWeight: 500,
    },
    "&:hover": {
        backgroundColor: "rgba(200, 200, 200, 0.7) !important",
        color: `${secondaryColor} !important`,
    },
    "&:focus": {
        color: `${secondaryColor} !important`,
    },
});

const menuProps = {
    PaperProps: {
        style: {
            backgroundColor: "rgb(255, 255, 255, 0.7)",
            maxHeight: "none",
            boxShadow: "none",
            borderRadius: "var(--radius-md)",
        },
    },
    disableScrollLock: false,
};
const dropdownMenuProps = {
    ...menuProps,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "right",
    },
};

const AdminRolesNavBar = ({
  workTypes,
  projectFile,
  handleWork,
  getTaskNameFormal,
  getLanguageName,
}) => {
  const navigate = useNavigate();

    return (
        <StyledSelect input={<BootstrapInput />} MenuProps={menuProps}>
            <StyledMenuItem
                onClick={() => navigate(`/projects/${projectFile.id}/manage`)}
                disableRipple
            >
                <span style={{ color: secondaryColor, fontWeight: 600 }}>
                    Manage
                </span>
            </StyledMenuItem>
            {workTypes?.map((type, index) => (
                <StyledMenuItem key={index} disableRipple>
                    <Grid
                        item
                        container
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Grid sx={{ color: secondaryColor, fontWeight: 600 }}>
                            {getTaskNameFormal(type)}
                        </Grid>
                        <Grid>
                            {[
                                "translate",
                                "performancedirection",
                                "performancedirectionversions",
                                "qualityassurance",
                                "lipqualityassurance",
                            ].includes(type) ? (
                                <StyledSelect
                                    size="small"
                                    defaultValue="Start Working"
                                    MenuProps={dropdownMenuProps}
                                >
                                    <StyledMenuItem value="Start Working">
                                        Start Working
                                    </StyledMenuItem>
                                    {projectFile?.finalLang?.map((language, langIndex) => (
                                        <StyledMenuItem
                                            key={langIndex}
                                            value={language}
                                            onClick={() => handleWork(projectFile, type, language)}
                                            disableRipple
                                            sx={{ color: secondaryColor, fontWeight: 500 }}
                                        >
                                            {getLanguageName(language)}
                                        </StyledMenuItem>
                                    ))}
                                </StyledSelect>
                            ) : (
                                <GlobalButton
                                    color="primary"
                                    onClick={() => handleWork(projectFile, type)}
                                >
                                    Start Working
                                </GlobalButton>
                            )}
                        </Grid>
                    </Grid>
                </StyledMenuItem>
            ))}
            <StyledMenuItem
                onClick={() => navigate(`/workpages/details/${projectFile.id}`)}
                disableRipple
            >
                <span style={{ color: secondaryColor, fontWeight: 600 }}>
                    Analyze
                </span>
            </StyledMenuItem>
            <StyledMenuItem
                onClick={() => navigate(`/actions/${projectFile.id}`)}
                disableRipple
            >
                <span style={{ color: secondaryColor, fontWeight: 600 }}>
                    Admin Actions
                </span>
            </StyledMenuItem>
            <StyledMenuItem
                onClick={() => navigate(`/projects/${projectFile.id}/voices`)}
                disableRipple
            >
                <span style={{ color: secondaryColor, fontWeight: 600 }}>
                    Voices
                </span>
            </StyledMenuItem>
            <StyledMenuItem
                onClick={() => navigate(`/projects/${projectFile.id}/character-customization`)}
                disableRipple
            >
                <span style={{ color: secondaryColor, fontWeight: 600 }}>
                    Casting
                </span>
            </StyledMenuItem>
        </StyledSelect>
    );
};

export default AdminRolesNavBar;
